module.exports = __webpack_public_path__ + "static/media/bo.5207c004.svg";